import { LatLng } from "use-places-autocomplete";
import {
  calculateDistanceBetweenTwoCoordinates,
  sortFranchise,
} from "../../../utils/help/location/locationHelp";
import { Restaurant } from "../../../utils/types";
import { InitialState } from "../slices/configSlice";
const lodashClonedeep = require("lodash.clonedeep");

export const handleSettingAllRestaurantDetails = (
  state: InitialState,
  newRestaurantDetails: Restaurant
) => {
  if (
    state.restaurantInfo &&
    newRestaurantDetails.id !== state.restaurantInfo.id
  ) {
    handleSelectPartnerRestaurant(
      state,
      newRestaurantDetails.id,
      state.restaurantInfo
      // true
    );
  } else {
    setAllRestaurantDetails(
      state,
      newRestaurantDetails,
      newRestaurantDetails.partnerRestaurants
    );
  }
};

export const handleSelectPartnerRestaurant = (
  state: InitialState,
  newPartnerRestaurantId: number,
  restaurant: Restaurant,
  refreshRestaurantData: boolean = false
) => {
  const newRestaurnatIndex = (
    refreshRestaurantData ? restaurant : state
  ).partnerRestaurants.findIndex(
    (res: Restaurant) => res.id === newPartnerRestaurantId
  );

  if (newRestaurnatIndex > -1) {
    const newPartners = [...state.partnerRestaurants];
    const newRestaurnat = {
      ...newPartners.splice(newRestaurnatIndex, 1)[0],
    };
    newRestaurnat.franchises = restaurant!.franchises;
    newPartners.push(restaurant!);
    setAllRestaurantDetails(state, newRestaurnat, newPartners);
  } else {
    setAllRestaurantDetails(state, restaurant, restaurant.partnerRestaurants);
  }

  // Set flags to indicate cart should be cleared and restaurant switch is in progress
  state.shouldClearCartDueToRestaurantSwitch = true;
  state.isRestaurantSwitchInProgress = true;
};

export const handleSortActiveFranchises = (
  state: InitialState,
  payload: LatLng
) => {
  for (let index = 0; index < state.activeFranchises.length; index++) {
    let currentFranchiseLocation: LatLng | undefined;

    if (
      state.activeFranchises[index]?.location &&
      state.activeFranchises[index].location?.lat &&
      state.activeFranchises[index].location?.lng
    ) {
      currentFranchiseLocation = state.activeFranchises[index].location;
    }

    const distanceFromLocationInMeters = currentFranchiseLocation
      ? calculateDistanceBetweenTwoCoordinates(
          payload,
          lodashClonedeep(currentFranchiseLocation)
        )
      : undefined;
    state.activeFranchises[index].distanceFromLocationInMeters =
      distanceFromLocationInMeters;
  }
  state.activeFranchises = state.activeFranchises.sort((a, b) =>
    sortFranchise(a, b)
  );
};

const setAllRestaurantDetails = (
  state: InitialState,
  restaurant: Restaurant,
  partnerRestaurants: Restaurant[]
) => {
  state.partnerRestaurants = partnerRestaurants;
  state.restaurantInfo = restaurant;
  state.restaurantConfig = restaurant.config;
  const activeFranchises = (restaurant?.franchises || []).filter(
    (f) => f.live && !f.franchiseConfig?.catering
  );
  state.activeFranchises = activeFranchises;
  if (state.selectedFranchise) {
    const currentFranchise = activeFranchises.find(
      (af) => af.id === state.selectedFranchise?.id
    );
    if (currentFranchise) {
      state.selectedFranchise = currentFranchise;
    }
  }
};
